<template>
  <a-config-provider :locale="locale">
    <div id="app" >
      <router-view/>
    </div>
  </a-config-provider>
</template>
<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import enquireScreen from '@/utils/device'
  import Recorder from 'js-audio-recorder'
  export default {
    data () {
      return {
        locale: zhCN,
        recording:false,
        recording2:false
      }
    },
    provide(){
      return{
        startRecorder:this.startRecorder,
        stopRecorder:this.stopRecorder,
        isRecording:this.isRecording,
        startRecorder2:this.startRecorder2,
        stopRecorder2:this.stopRecorder2,
        isRecording2:this.isRecording2
      }
    },
    created () {
      let that = this
      enquireScreen(deviceType => {
        // tablet
        if (deviceType === 0) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        // mobile
        else if (deviceType === 1) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        else {
          that.$store.commit('TOGGLE_DEVICE', 'desktop')
          that.$store.dispatch('setSidebar', true)
        }

      })
      this.initRecord()
      window.addEventListener('unload', this.unload)
    },
    methods:{
      initRecord(){
        const MicRecorder = require('mic-recorder-to-mp3');
        window.myRecorder = new MicRecorder({
          bitRate: 128
        });
        window.myRecorder2 = new MicRecorder({
          bitRate: 128
        });
        // console.log(window.myRecorder2)
      },
      startRecorder(callback){
        if(this.recording){
          return
          // return this.$message.warning('当前正在录音，请手动关闭录音或者刷新页面。')
        }
        this.recording = true
        window.myRecorder.start().then(callback, (error) => {
          this.recording = false
          // 出错了
          this.$nextTick(()=>{
            this.$message.warning('录音失败：请检查您的录音权限和设备是否正常！')
          })
        })
      },
      startRecorder2(callback){
        if(this.recording2){
          return
        }
        this.recording2 = true
        window.myRecorder2.start().then(callback, (error) => {
          this.recording2 = false
          // 出错了
          this.$nextTick(()=>{
            this.$message.warning('录音失败：请检查您的录音权限和设备是否正常！')
          })
        })
      },
      stopRecorder(callback){
        window.myRecorder.stop()
        const getMp3 = window.myRecorder.getMp3()
        if(callback){
          callback(getMp3)
        }
        this.recording = false
        return getMp3
      },
      stopRecorder2(callback){
        window.myRecorder2.stop()
        const getMp3 = window.myRecorder2.getMp3()
        if(callback){
          callback(getMp3)
        }
        this.recording2 = false
        return getMp3
      },
      isRecording(){
        return this.recording
      },
      isRecording2(){
        return this.recording2
      },
      unload (event) {
        this.stopRecorder()
        this.stopRecorder2()
      },
    }
  }
</script>
<style lang="less">
  #app {
    height: 100%;
  }
  .one-row{
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block !important;
  }
  .center-panel{
    text-align: center;
  }
  .ant-card-head{
    min-height: 1px !important;
    .ant-card-head-title{
      padding: 5px 0 !important;
    }
    .ant-card-extra{
      padding: 5px 0 !important;
    }
  }


  .ant-input-number-disabled,
  .ant-radio-disabled + span ,
  .ant-input-disabled,
  .ant-checkbox-disabled + span,
  .ant-slider-mark-text,
  .ant-select-disabled{
    color: rgba(0,0,0,0.8) !important;
    background: none !important;
  }
  .ant-radio-button-wrapper-disabled{
    color: rgba(0,0,0,0.8) !important;
    /*background: none !important;*/
  }
  .select-center-chart{
    background: #282A2F !important;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05), 0px 15px 35px -2px rgba(0, 0, 0, 0.05) !important;
    border-radius: 4px 4px 4px 4px !important;
    border: 1px solid rgba(234, 237, 241, 0.05) !important;
    .ant-select-dropdown-menu-item{
      color: #C7CCD6 !important;
    }
    .ant-select-dropdown-menu-item-selected{
      background-color: #f6f8fa !important;
      color: #1664FF !important;
    }
  }
  .select-center-time {
    background: #282A2F !important;
    .ant-calendar{
      background: #282a2f !important;
      border: 1px solid rgba(234,237,241,0.05);
      .ant-calendar-input {
        background: #282A2F !important;
        font-weight: 400;
        font-size: 13px;
        color: #C7CCD6;
      }
      .ant-calendar-year-select,.ant-calendar-month-select{
        font-weight: 400;
        font-size: 13px;
        color: #C7CCD6;
      }
      .ant-calendar-column-header-inner{
        font-weight: 400;
        font-size: 13px;
        color: #737A87;
      }
      .ant-calendar-input-wrap{
        border-bottom: 1px solid #2f3136;
      }
      .ant-calendar-body {
        border-top: 1px solid #2f3136;
      }
      .ant-calendar-date{
        font-weight: 400;
        font-size: 13px;
        color: #737A87;
      }
      .ant-calendar-last-month-cell{
        .ant-calendar-date{
            font-weight: 400;
            font-size: 13px;
            color: #42464E;
        }
      }
      .ant-calendar-selected-day {
        .ant-calendar-date {
          background: #1664FF;
          box-shadow: 0px 1px 0px 0px rgba(20,20,20,0.08);
          border-radius: 20px 20px 20px 20px;
          border: 1px solid #1759DD;
        }
      }
      .ant-calendar-in-range-cell {
        .ant-calendar-date {
          background: rgba(31, 53, 97, 1);
          border-radius: 20px 20px 20px 20px;
          border: 1px solid rgba(31, 53, 97, 1);
          color: #9DA3AF;
        }
      }
      .ant-calendar-in-range-cell::before {
        background-color: #23304b;
      }
      .ant-calendar-today {
        .ant-calendar-date {
         background: rgba(31, 53, 97, 1);
         border-radius: 20px 20px 20px 20px;
         border: 1px solid rgba(31, 53, 97, 1);
         color: #9DA3AF;
        }
        
      }
      .ant-calendar-date:hover {
        background: #1664FF;
        box-shadow: 0px 1px 0px 0px rgba(20,20,20,0.08);
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #1759DD;
        color: #fff;
      }
      .ant-calendar-last-month-cell .ant-calendar-date:hover {
        background: transparent;
        color: #42464e;
        border-color: transparent;
      }
    }
  }
</style>